<template>
  <div>
    <h1 class="p-lg">Pills</h1>
    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>Default</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            class="mr-{10px}"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Hoverable</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            hoverable
            class="mr-{10px}"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Selected</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            selected
            class="mr-{10px}"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Toggleable</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            hoverable
            :selected="status('inProgress')"
            @click.native="() => toggle('inProgress')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            hoverable
            :selected="status('draft')"
            @click.native="() => toggle('draft')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            hoverable
            :selected="status('signed')"
            @click.native="() => toggle('signed')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            hoverable
            :selected="status('rejected')"
            @click.native="() => toggle('rejected')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            hoverable
            :selected="status('unverified')"
            @click.native="() => toggle('unverified')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            hoverable
            :selected="status('expired')"
            @click.native="() => toggle('expired')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            hoverable
            :selected="status('cancelled')"
            @click.native="() => toggle('cancelled')"
            class="mr-{10px}"
          />
        </div>
      </div>
    </div>
    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>Default (large)</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            size="large"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            size="large"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            size="large"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            size="large"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            size="large"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            size="large"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            size="large"
            class="mr-{10px}"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Hoverable (large)</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            size="large"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            size="large"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            size="large"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            size="large"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            size="large"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            size="large"
            hoverable
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            size="large"
            hoverable
            class="mr-{10px}"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Selected (large)</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            size="large"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            size="large"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            size="large"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            size="large"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            size="large"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            size="large"
            selected
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            size="large"
            selected
            class="mr-{10px}"
          />
        </div>
      </div>
      <div class="mb-lg">
        <p><strong>Toggleable (large)</strong></p>
        <div class="flex flex-row">
          <EnvelopeStatusPill
            text="In Progress (35)"
            variant="inProgress"
            size="large"
            hoverable
            :selected="status('inProgress')"
            @click.native="() => toggle('inProgress')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Draft (23)"
            variant="draft"
            size="large"
            hoverable
            :selected="status('draft')"
            @click.native="() => toggle('draft')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Signed (35)"
            variant="signed"
            size="large"
            hoverable
            :selected="status('signed')"
            @click.native="() => toggle('signed')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Rejected (43)"
            variant="rejected"
            size="large"
            hoverable
            :selected="status('rejected')"
            @click.native="() => toggle('rejected')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Unverified (31)"
            variant="unverified"
            size="large"
            hoverable
            :selected="status('unverified')"
            @click.native="() => toggle('unverified')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Expired (13)"
            variant="expired"
            size="large"
            hoverable
            :selected="status('expired')"
            @click.native="() => toggle('expired')"
            class="mr-{10px}"
          />
          <EnvelopeStatusPill
            text="Cancelled (24)"
            variant="cancelled"
            size="large"
            hoverable
            :selected="status('cancelled')"
            @click.native="() => toggle('cancelled')"
            class="mr-{10px}"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EnvelopeStatusPill from '@/components/ui/envelopes/EnvelopeStatusPill.vue';

export default {
  components: {
    EnvelopeStatusPill,
  },
  data() {
    return {
      pills: {
        inProgress: false,
        draft: false,
        signed: false,
        rejected: false,
        unverified: false,
        expired: false,
        cancelled: false,
      },
    };
  },
  computed: {
    status() {
      return variant => this.pills[variant];
    },
  },
  methods: {
    toggle(variant) {
      this.pills[variant] = !this.pills[variant];
    },
  },
};
</script>
